import { MenuItem, Select, Typography } from "@mui/material";
import Divider from "@mui/material/Divider";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import { Fragment } from "react/jsx-runtime";

export default function CustomTextFiled({
  label,
  onInputChange,
  inputValue,
  inputHeight = "56px",
  inputProps = {},
  showEndDropDown = false,
  dropDownValue = "per hour",
  dropDownOptions = [
    { id: "per hour", name: "per hour" },
    { id: "per day", name: "per day" },
  ],
  onDropDownChange,
  dropDownProps = {},
  showError = false,
  errorMessage = " ",
  dropDownPosition = "right",
  showVerifiedIconAtEnd = false,
  inputRef = null,
  paramProps = null,
  multiline = false,
  type = "text",
  rows = 1,
}: any) {
  const EndDropDown = showEndDropDown ? (
    <Fragment>
      {dropDownPosition == "right" && (
        <Divider
          key="label"
          sx={{ height: 28, m: 0.5, color: "#A2A2A2" }}
          orientation="vertical"
        />
      )}
      <Select
        value={dropDownValue}
        sx={{
          padding: 0.5,
          boxShadow: "none",
          ".MuiOutlinedInput-notchedOutline": { border: 0 },
        }}
        disableUnderline={true}
        variant="standard"
        onChange={(e) => onDropDownChange(e.target.value)}
        {...dropDownProps}
      >
        {dropDownOptions?.map((el: any) => (
          <MenuItem value={el?.id}>{el?.name}</MenuItem>
        ))}
      </Select>
      {dropDownPosition == "left" && (
        <Divider
          key="divider"
          sx={{ height: 28, m: 0.5, color: "#A2A2A2" }}
          orientation="vertical"
        />
      )}
    </Fragment>
  ) : null;
  return (
    <Fragment>
      <Paper
        component="div"
        sx={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          boxShadow: "none",
          border: "1px solid #dfdfdf",
        }}
      >
        {dropDownPosition == "left" && EndDropDown}
        <InputBase
          ref={inputRef}
          sx={{ ml: 1, flex: 1, height: inputHeight }}
          placeholder={label}
          fullWidth
          multiline={multiline}
          rows={rows}
          onChange={onInputChange}
          value={inputValue}
          type={type}
          {...inputProps}
          {...(paramProps && paramProps)}
        />
        {dropDownPosition == "right" && EndDropDown}
        {showVerifiedIconAtEnd && (
          <img
            alt="verified"
            src={require("assets/img/png/verified.png")}
            style={{ width: "24px", height: "24px", marginRight: "8px" }}
          />
        )}
      </Paper>{" "}
      {showError && (
        <Typography color="error" variant="caption">
          {errorMessage || " "}
        </Typography>
      )}
    </Fragment>
  );
}
